import { types } from '~/utils/typeCreator'

export default types(['SET_SUBSCRIPTION', 'CLEAR_STATE'], 'NOTICE_EVALUATION')
